/**
 * This method resolves which Apple Pay version we are going to use.
 * The latest version is 11, version 3 is the lowest denominator that is widely supported.
 * const session: ApplePaySession = new window.ApplePaySession(getApplePayVersion(), request);
 * @returns {number}
 */
export const getApplePayVersionToUse = () => 4; // NOTE: in future maybe it worth adding some logic to use latest API version capabilities
